import { useMemo } from 'react'

import type { AITaskType } from '@/api/types'
import { modelMatchesTaskType, useModels } from '@/shared/hooks/useModels'

/** Studio 侧薄封装：复用全局模型缓存，避免 items=null 时对非数组调用 filter */
export function useAIModels() {
  const { allModels, loading, error } = useModels()

  const byType = useMemo(() => {
    return (type: AITaskType) => allModels.filter((m) => modelMatchesTaskType(m, type))
  }, [allModels])

  const defaultModelId = (type: AITaskType) => byType(type)[0]?.id ?? ''

  return { models: allModels, loading, error, byType, defaultModelId }
}
